import { FC, createContext, useContext, ReactNode, useState } from 'react'
import { LangType, TextsType } from '../types'
import cz from './cz'
import en from './en'
/*const locales = {
  cz: texts,
};*/
//const locale = locales["cz"];
const textMap = { cz, en }
type LanguageContextType = {
  lang: LangType
  texts: TextsType
  setLang: (lang: LangType) => void
}

const LanguageContext = createContext<LanguageContextType>({
  lang: 'cz',
  texts: textMap.cz,
  setLang: () => {},
})

export const LanguageContextProvider: FC<{ children?: ReactNode }> = ({
  children,
}) => {
  const [lang, setLang] = useState<LangType>('cz')
  return (
    <LanguageContext.Provider value={{ lang, setLang, texts: textMap[lang] }}>
      {children}
    </LanguageContext.Provider>
  )
}

export function useLanguage(): LanguageContextType {
  const context = useContext(LanguageContext)
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider')
  }
  return context
}
